var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVMirrored = function SvgVMirrored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.816 13.842-3.753 6.5-3.753-6.5h3.103V3.658h1.3v10.184zm9.5-3.684-3.753-6.5-3.753 6.5h3.103v10.184h1.3V10.158z"
  })));
};
export { SvgVMirrored as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogIDxwYXRoIGQ9Ik0xMS44MTYgMTMuODQybC0zLjc1MyA2LjUtMy43NTMtNi41aDMuMTAzVjMuNjU4aDEuM3YxMC4xODRoMy4xMDN6bTkuNS0zLjY4NGwtMy43NTMtNi41LTMuNzUzIDYuNWgzLjEwM3YxMC4xODRoMS4zVjEwLjE1OGgzLjEwM3oiLz4KPC9zdmc+Cg==";